<template>
  <div id="HistoryTopUp">
    <b-navbar type="light" variant="light-success">
      <b-button v-b-toggle.sidemenu variant="outline-secondary" class="mr-2 d-lg-none"><f-icon icon="bars"></f-icon></b-button>
      <b-navbar-brand  class="mb-0" :to="{ path: '/ld' }" replace>
        <img :src="logoImg" class="d-inline-block align-top" alt="Logo" height="30px">
        {{ logoName }}
      </b-navbar-brand>
    </b-navbar>
    <b-sidebar id="sidemenu" title="Menu" body-class="px-2" shadow>
      <left-menu></left-menu>
    </b-sidebar>
    <b-container fluid class="bg-white shadow-sm">
      <b-row>
        <b-col cols="3" class="d-none d-lg-block pb-4 pt-2">
          
          <left-menu></left-menu>
        </b-col>
        <b-col lg="9" class="pt-4 pb-4 animate__animated animate__fadeIn">
          <alert-card></alert-card>
          <h2>ประวัติการเติมเงิน</h2>
          <b-overlay
            id="overlay-dataSlipReady"
            :show="!dataSlipReady"
            variant="light"
            :opacity="0.95"
            blur="4px"
            rounded="sm"
          >
            <template #overlay>
              <div class="text-center">
                <h4 id="cancel-label">กำลังเรียกดูข้อมูล</h4>
              </div>
            </template>
          
            <b-table striped bordered small responsive
              :items="topUpItems" :fields="topUpFields"
              show-empty empty-text="ไม่พบการเติมเงินเข้าระบบ"
              :tbody-tr-class="rowSuccessClass"
              class="table-mini">

              <template #cell(showDetails)="row">
                <b-button size="sm" @click="row.toggleDetails">
                  <f-icon icon="receipt"></f-icon> {{ row.detailsShowing ? 'ซ่อน' : 'แสดง' }}สลิป
                </b-button>
              </template>

              <template #cell(createTopUptime)="data">
                {{ data.value.date }} {{ data.value.time }}
              </template>

              <template #row-details="row">
                  <b-row class="my-2">
                    <b-col>
                      <b-img thumbnail fluid width="300" center 
                        :src="row.item.pictureSlipTopUp" v-if="row.item.pictureSlipTopUp" 
                        alt="หลักฐานการโอนเงิน"></b-img>
                    </b-col>
                  </b-row>
              </template>

            </b-table>
          </b-overlay>

        </b-col>
      </b-row>
    </b-container>
    <b-container fluid class="text-center mt-3 mb-2">
      {{ footerLC }}
    </b-container>
  </div>
</template>

<script>
import axios from "axios"; // api
import MenuBar from '@/components/Menubar' // เมนู
import AlertCard from '@/components/Alert' // แจ้งเดือน
export default {
  name: "HistoryTopUp",
  components: {
    'left-menu': MenuBar,
    'alert-card': AlertCard
  },
  beforeCreate() {
    // เหตุการจะเกิดขึ้นก่อนที่ Component จะถูก render เข้าไปใน DOM
    // this.$liff.init({ liffId: this.$liff_register_profile }, function (data) {})
  },
  created() {
    // ทุกอย่างจะถูกเตรียมไว้ครบหมดแล้ว และสามารถเข้าถึงได้หมด
    // setInterval(this.getDataMap, 1000)
  },
  async mounted() {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น
    this.getDataUser()
    await this.getDataTopUp()
  },
  data() {
    return {
      userData: {
        userName: '',
        firstName: '',
        lastName: '',
        telephoneNumber: '',
        userType: ''
      },
      form: {
        bankAccountLicm: "027-8-24576-4",
        transferDate: "",
        transferTime: "",
        amount:  "",
        amountText:  "",
        pictureSlipTopUp: "",
        noteSlipTopUp: "",
        userName: "",
        userCode: "",
        CREATE_USER: "",
        status: "รอยืนยันการเติมเงิน",
      },
      fileimg: null,
      dataReady: false,
      dataSlipReady: false,
      topUpFields: [
        { key: 'createTopUptime', label: 'แจ้งเติมเงินเวลา' },
        { key: 'transferDate', label: 'วันที่เติมเงิน' },
        { key: 'transferTime', label: 'เวลาเติมเงิน' },
        { key: 'amount', label: 'จำนวนเงิน' },
        { key: 'noteSlipTopUp', label: 'รายละเอียดเพิ่มเติม' },
        { key: 'status', label: 'สถานะการเติมเงิน' },
        { key: 'showDetails', label: 'หลักฐานสลิป' }
      ],
      topUpItems: [],
    };
  },
  methods: {
    formatDate (strDate) {
      if (strDate) {
        var dtDate = strDate.split(' ')[0]
        var strDateShort = dtDate.split('-')[2] + '/' + dtDate.split('-')[1] + '/' + dtDate.split('-')[0]
        return strDateShort
      } else {
        return ''
      }
    },
    rowSuccessClass (item, type) {
      if (!item || type !== 'row') return
      if (item.status === 'ยืนยันยอดเงิน') return 'table-success'
      if (item.status === 'รอยืนยันการเติมเงิน') return 'table-warning'
    },
    getDataUser() {
      let lsUser = this.getDataStorageUser()
      if (lsUser) {
        this.userData = lsUser

        this.form.CREATE_USER = this.userData.userName
        this.form.userName = this.userData.userName
        this.form.userCode = this.userData.userCode

        this.dataReady = true
      } else {
        this.$router.push('/Login')
      }      
    },
    getDataTopUp () {
      this.dataSlipReady = false
      this.topUpItems = []
      let uc = ""
      if (this.userData.userCode) { uc = '&userCode=' + this.userData.userCode }
      axios
        .get(
          // eslint-disable-next-line quotes
          'https://licm-cargo.com/api/Slip_top_up/Slip_top_up_list?userName=' +
          this.userData.userName +
          '&userType=' +
          this.userData.userType +
          uc +
          '&top=50',
          {
            headers: this.getHeaderAPI('Slip_top_up_list', this.userData.userName)
          }
        )
        .then((response) => {
          // console.log('getDataTopUp', response.data)

          let rs = response.data
          if (rs.status === true){
            if (rs.data.length > 0) {
              // this.totalRows = rs.data.length
              for (let i = 0; i < rs.data.length; i++) {
                let topUpData = rs.data[i]

                topUpData.createTopUptime = this.formatDateTime(rs.data[i].CREATE_DATE)
                // topUpData.lastDatetime = this.formatDateTime(rs.data[i].LAST_DATE)

                this.topUpItems.push(topUpData)
              }

              console.log('getDataTopUp', this.topUpItems)
            }
          }

          this.dataSlipReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('getDataTopUp error:', error)
          this.dataSlipReady = true
          this.topUpItems = []
        });
    },
    getFileBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    async uploadFile () {
      if (this.fileimg) {
        await this.getFileBase64(this.fileimg)
          .then(picBase64 => {
            // console.log('uploadFile Base64', picBase64)
            this.form.pictureSlipTopUp = picBase64
          })
      }
    },
    // onInvoiceSelected (invoice) {
    //   // let dataInvice = invoice[0]
    //   console.log("onInvoiceSelected", invoice)
    //   if (invoice.length > 0) {
    //     this.form.deliverDoc = invoice[0].deliverDoc
    //   } else {
    //     this.form.deliverDoc = ''
    //   }
    // },
    onSubmit () {
      console.log("onSubmit Data:", this.form)

      this.form.amount = this.form.amountText.split(',').join('')
      delete this.form.amountText
      
      this.dataReady = false
      axios
        .post(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/Slip_top_up/Slip_top_up_add",
          this.form,
          {
            headers: this.getHeaderAPI('Slip_top_up_add', this.form.userName)
          }
        )
        .then(async (response) => {
          console.log('onSubmit', response)
          let rs = response.data
          if (rs.status === true) {
            this.$swal("สำเร็จ","แจ้งการเติมเงินเรียบร้อย","success")
              .then((result) => {
                this.$router.push('/Route?target=TopUp&uriType=User')
              })
            this.dataReady = true
          } else {
            console.log('onSubmit Fail')
            this.$swal("ผิดพลาด","ไม่สามารถแจ้งการเติมเงินได้ กรุณาติดต่อแอดมิน","error")
            this.dataReady = true
          }
        })
        .catch((error) => {
          console.log(error.response)
          this.$swal("Error Insert","ไม่สามารถแจ้งการเติมเงินได้ กรุณาติดต่อแอดมิน","error")
          this.dataReady = true
        })
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#form-profile {
  text-align: left;
}

.py-75{
  padding-top: .75rem !important;
  padding-bottom: .75rem !important;
}

.ex-card{
  border-style: dotted;
  border-width: 2px;
}

.ex-card > .card-body {
  padding: .75rem;
}

.dropdown-menu {
  min-width: 5rem !important;
  /* text-align: center; */
}
</style>



// WEBPACK FOOTER //
// src/components/User/HistoryTopUp.vue